<template>
  <div class="line-container" v-if="data.length">
    <div class="line-content" :style="{ height: lineHeight }">
      <div
        class="line-item"
        v-for="(item, index) in data"
        :key="index"
        :style="{
          backgroundColor: dealColor(item.water_color),
          opacity: computeOpacity(index)
        }"
      ></div>
    </div>
    <div class="line-flag" v-show="curStatus !== 0" :style="{ bottom: height }">
      <img
        class="flag-image"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b9b64198bf8055df550a91c6edafa954.png"
        alt=""
      />
      <div class="flag-dash"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    status: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      curStatus: 0,
      colorList: [
        {
          time: '08:00',
          edit: true,
          color: '#C3CDDA',
          ml: '400ml'
        },
        {
          time: '09:00',
          color: '#FF1149',
          ml: '300ml'
        },
        {
          time: '10:00',
          color: '#FF9854',
          ml: '400ml'
        },
        {
          time: '11:30',
          color: '#FFBD01',
          ml: '300ml'
        },
        {
          time: '14:00',
          color: '#49DEA5',
          ml: '400ml'
        },
        {
          time: '16:00',
          color: '#35C5F4',
          ml: '350ml'
        },
        {
          time: '18:00',
          color: '#467BF8',
          ml: '250ml'
        },
        {
          time: '20:00',
          color: '#CB80E5',
          ml: '200ml'
        }
      ],
      totalCount: 9, //总格子数
      height: '0%'
    }
  },
  computed: {
    lineHeight() {
      return (this.data.length / this.totalCount) * 100 + '%'
    }
  },
  watch: {
    status(newval, oldval) {
      setTimeout(() => {
        this.updateData()
      }, 500)
    },
    data() {
      this.updateColor()
    }
  },
  mounted() {
    this.curStatus = this.status
    this.updateColor()
    this.updateData()
  },
  methods: {
    //处理透明颜色 变成半透明
    dealColor(str) {
      return str == 'rgba(0,0,0,0)' ? 'rgba(195, 205, 218, 1)' : str
    },
    computeOpacity(index) {
      let opacity = index < this.data.length - this.curStatus ? 0.3 : 1
      return opacity
    },
    updateData() {
      this.height = (this.status / this.colorList.length) * 100 + '%'
      setTimeout(() => {
        this.curStatus = this.status
      }, 500)
    },
    updateColor() {
      let res = this.data.map((item) => {
        return item
      })
      let number = this.totalCount
      if (res.length < number) {
        let num = number - res.length
        for (let i = 0; i < num; i++) {
          res.unshift({
            water_color: 'transparent'
          })
        }
      }
      this.colorList = res
    }
  }
}
</script>
<style lang="scss" scoped>
.line-container {
  height: 100%;
  position: relative;
  display: flex;
  align-items: flex-end;
  .line-content {
    width: 16px;
    height: 100%;
    border-radius: 45px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    overflow: hidden;
    .line-item {
      flex: 1;
    }
  }
  .line-flag {
    position: absolute;
    right: -10px;
    /*  top: 0%; */
    width: 36px;
    height: 28px;
    transform: translate(0%, 50%);
    transition: bottom 0.3s linear;
    .flag-image {
      width: 100%;
      height: 100%;
    }
    .flag-dash {
      position: absolute;
      right: 100%;
      top: 50%;
      width: 29px;
      transform: translate(0%, -50%);
      height: 0px;
      border-bottom: 1px dashed rgba(0, 0, 0, 0.3);
    }
  }
}
</style>
